import {
  FETCH_USERS,
  FETCH_USERS_SUCCESS,
  FETCH_USERS_FAILED,
  INVITE_USER,
  INVITE_USER_SUCCESS,
  INVITE_USER_FAILED,
  DISABLE_USER,
  DISABLE_USER_SUCCESS,
  DISABLE_USER_FAILED,
  CHANGE_USER_ROLE,
  CHANGE_USER_ROLE_SUCCESS,
  CHANGE_USER_ROLE_FAILED,
  RESET_INVITE_USER,
} from './constants';

export const fetchUsers = () => ({
  type: FETCH_USERS,
});

export const fetchUsersSuccess = (users) => ({
  type: FETCH_USERS_SUCCESS,
  payload: users,
});

export const fetchUsersFailed = (error) => ({
  type: FETCH_USERS_FAILED,
  payload: error,
});

export const inviteUser = (email, name, roleNumber) => ({
  type: INVITE_USER,
  payload: { email, name, roleNumber },
});

export const inviteUserSuccess = (response) => ({
  type: INVITE_USER_SUCCESS,
  payload: response,
});

export const inviteUserFailed = (error) => ({
  type: INVITE_USER_FAILED,
  payload: error,
});

export const disableUser = (userEmail) => ({
  type: DISABLE_USER,
  payload: { userEmail },
});

export const disableUserSuccess = (response) => ({
  type: DISABLE_USER_SUCCESS,
  payload: response,
});

export const disableUserFailed = (error) => ({
  type: DISABLE_USER_FAILED,
  payload: error,
});

export const changeUserRole = (userEmail, newRole) => ({
  type: CHANGE_USER_ROLE,
  payload: { userEmail, newRole },
});

export const changeUserRoleSuccess = (response) => ({
  type: CHANGE_USER_ROLE_SUCCESS,
  payload: response,
});

export const changeUserRoleFailed = (error) => ({
  type: CHANGE_USER_ROLE_FAILED,
  payload: error,
});

export const resetInviteUser = () => ({
  type: RESET_INVITE_USER,
});